import './GenerateCta.svelte.css';
/* src/components/GenerateCta.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	attr,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import { areas } from "../stores/index.js";
import { DialogOverlay } from "../../_snowpack/pkg/svelte-accessible-dialog.js";
import GenerateContent from "./GenerateContent.svelte.js";

function create_if_block(ctx) {
	let button;
	let mounted;
	let dispose;

	return {
		c() {
			button = element("button");
			button.textContent = "Generate";
			attr(button, "class", "jd-primary-button svelte-rngd0v");
		},
		m(target, anchor) {
			insert(target, button, anchor);

			if (!mounted) {
				dispose = listen(button, "click", /*openGenerate*/ ctx[2]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

// (18:0) <DialogOverlay isOpen={isGenerateOpen} onDismiss={closeGenerate}>
function create_default_slot(ctx) {
	let generatecontent;
	let current;
	generatecontent = new GenerateContent({});
	generatecontent.$on("close", /*closeGenerate*/ ctx[3]);

	return {
		c() {
			create_component(generatecontent.$$.fragment);
		},
		m(target, anchor) {
			mount_component(generatecontent, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(generatecontent.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(generatecontent.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(generatecontent, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let t;
	let dialogoverlay;
	let current;
	let if_block = /*$areas*/ ctx[1]?.length && create_if_block(ctx);

	dialogoverlay = new DialogOverlay({
			props: {
				isOpen: /*isGenerateOpen*/ ctx[0],
				onDismiss: /*closeGenerate*/ ctx[3],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			t = space();
			create_component(dialogoverlay.$$.fragment);
			attr(div, "class", "generate-container svelte-rngd0v");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
			insert(target, t, anchor);
			mount_component(dialogoverlay, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*$areas*/ ctx[1]?.length) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(div, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			const dialogoverlay_changes = {};
			if (dirty & /*isGenerateOpen*/ 1) dialogoverlay_changes.isOpen = /*isGenerateOpen*/ ctx[0];

			if (dirty & /*$$scope*/ 16) {
				dialogoverlay_changes.$$scope = { dirty, ctx };
			}

			dialogoverlay.$set(dialogoverlay_changes);
		},
		i(local) {
			if (current) return;
			transition_in(dialogoverlay.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(dialogoverlay.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
			if (detaching) detach(t);
			destroy_component(dialogoverlay, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $areas;
	component_subscribe($$self, areas, $$value => $$invalidate(1, $areas = $$value));
	let isGenerateOpen;

	const openGenerate = () => {
		$$invalidate(0, isGenerateOpen = true);
	};

	const closeGenerate = () => {
		$$invalidate(0, isGenerateOpen = false);
	};

	return [isGenerateOpen, $areas, openGenerate, closeGenerate];
}

class GenerateCta extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default GenerateCta;